import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import styled, { css } from "styled-components";
import { ConfigurationForm } from "components/configurationforms";
import { Select } from "components/common";
import generateObjectId from "logic/generateObjectId";
import InlineForm from "./InlineForm";
import PopoverHelp from "./PopoverHelp";
import DecoratorStyles from "./decoratorStyles.css";
const ConfigurationFormContainer = styled.div(
  ({ theme }) => css`
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 5px;
    display: inline-block;
    border-style: solid;
    border-color: ${theme.colors.gray[80]};
    border-radius: 5px;
    border-width: 1px;
    padding: 10px;
    background: ${theme.colors.global.background};
  `
);
const _formatDecoratorType = (typeDefinition, typeName) => ({
  value: typeName,
  label: typeDefinition.name
});
const AddDecoratorButton = ({
  decoratorTypes,
  disabled = false,
  showHelp = true,
  stream = null,
  nextOrder,
  onCreate
}) => {
  const [typeName, setTypeName] = useState(void 0);
  const [typeDefinition, setTypeDefinition] = useState(void 0);
  const _handleCancel = () => {
    setTypeDefinition(void 0);
    setTypeName(void 0);
  };
  const _handleSubmit = useCallback(
    (data) => {
      const request = {
        id: generateObjectId(),
        stream,
        type: data.type,
        config: data.configuration,
        order: nextOrder
      };
      onCreate(request);
      setTypeName(void 0);
    },
    [nextOrder, onCreate, stream]
  );
  const _onTypeChange = useCallback(
    (decoratorType) => {
      var _a;
      setTypeName(decoratorType);
      setTypeDefinition((_a = decoratorTypes[decoratorType]) != null ? _a : {});
    },
    [decoratorTypes]
  );
  const decoratorTypeOptions = useMemo(
    () => Object.entries(decoratorTypes).map(([name, type]) => _formatDecoratorType(type, name)),
    [decoratorTypes]
  );
  const wrapperComponent = InlineForm();
  const configurationForm = typeName !== void 0 ? /* @__PURE__ */ React.createElement(
    ConfigurationForm,
    {
      key: "configuration-form-output",
      configFields: typeDefinition.requested_configuration,
      title: `Create new ${typeDefinition.name}`,
      typeName,
      includeTitleField: false,
      wrapperComponent,
      submitAction: _handleSubmit,
      cancelAction: _handleCancel
    }
  ) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: `${DecoratorStyles.decoratorBox} ${DecoratorStyles.addDecoratorButtonContainer}` }, /* @__PURE__ */ React.createElement("div", { className: DecoratorStyles.addDecoratorSelect }, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: "Select decorator",
      onChange: _onTypeChange,
      options: decoratorTypeOptions,
      disabled,
      value: typeName
    }
  ))), showHelp && /* @__PURE__ */ React.createElement(PopoverHelp, null), typeName && /* @__PURE__ */ React.createElement(ConfigurationFormContainer, null, configurationForm));
};
export default AddDecoratorButton;
